import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=14fb4828"
import script from "./bottomBar.vue?vue&type=script&lang=js"
export * from "./bottomBar.vue?vue&type=script&lang=js"
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=14fb4828&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports